import AppConfig from "util/AppConfig";
import EnterpriseRoutes from "../EnterpriseRoutes";
export const COLLECTIONS_FEATURE_FLAG = "collections";
export const COLLECTIONS_ENABLED = AppConfig.isFeatureEnabled(COLLECTIONS_FEATURE_FLAG);
export const COLLECTIONS_ROUTE = {
  path: EnterpriseRoutes.COLLECTIONS,
  description: "Collections"
};
export const COLLECTION_EXCLUDED_ENTITY_TYPES = ["collection", "team"];
